<template>
  <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
  <div class="feature-flags">
    Feature flags
    <ul>
      <li
        v-for="[key, value] in entries"
        :key="key"
      >
        <label :for="key">
          <input
            v-if="typeof value === 'boolean'"
            :id="key"
            :checked="value"
            class="checkbox"
            :name="key"
            type="checkbox"
            @change="setValue(key, !value)"
          >
          <input
            v-else
            :id="key"
            :checked="true"
            class="checkbox"
            :disabled="true"
            :name="key"
            type="checkbox"
          >
          {{ key }}
          <input
            v-if="typeof value === 'number'"
            :id="`${key}-value`"
            class="value"
            :name="key"
            type="number"
            :value="value"
            @change="(event) => setValue(key, Number((event.target as HTMLInputElement).value))"
          >
        </label>
      </li>
      <li v-if="projectId && isDummyAlgorithm">
        <FeatureFlagsConfigurationDummy :project-id="projectId" />
      </li>
    </ul>
    Changes made here will be persisted in browser storage and will be available until the site data is cleared.
    <br>
    <br>
    <q-btn
      class="q-px-md q-py-none no-hover reset"
      dense
      no-caps
      outline
      @click="reset"
    >
      Reset
    </q-btn>
  </div>
</template>

<script lang="ts" setup>
import {
  onMounted,
  ref,
} from 'vue'
import { useRoute } from 'vue-router'
import { features } from '~services/features'
import { useProjectsStore } from '~stores/projectsStore/useProjectsStore'
import FeatureFlagsConfigurationDummy from './FeatureFlagsConfigurationDummy.vue'


const route = useRoute()
const { loadProjectByName } = useProjectsStore()
const projectId = ref<string | undefined>()
const isDummyAlgorithm = ref(false)

onMounted(async () => {
  const projectName = route.params.projectName as string
  if (projectName) {
    const project = await loadProjectByName(projectName)
    if (project) {
      projectId.value = project.id
      isDummyAlgorithm.value = project.defaultAlgorithmId === 'ai.robovision.algorithms.dummy'
    }
  }
})

const {
  entries,
  reset,
  setValue,
} = features
</script>

<style lang="sass" scoped>
@use 'sass:color'

.feature-flags
  .checkbox
    vertical-align: middle

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button
      -webkit-appearance: none
      margin: 0

  input[type="number"]
      -moz-appearance: textfield

  .value
    font-size: 0.75rem
    width: 2.5rem
    border-radius: 5px
    border: 1px solid #000
    margin-left: 5px
    padding: 0 3px

  .reset
    font-family: sans-serif
    font-size: 0.85rem
    font-weight: normal

    ::v-deep(.q-btn__content)
      color: black
</style>
